import { ColumnDef } from '@tanstack/react-table';
import ExpanderCell from './ExpanderCell';

/**
 * Создаёт колонку-expander для раскрытия строк.
 * Аналог createSelectionColumn — автоматически добавляется при наличии renderSubComponent.
 */
export function createExpanderColumn<T>(): ColumnDef<T> {
  return {
    id: 'expander',
    enableResizing: false,
    enableSorting: false,
    maxSize: 40,
    header: () => null,
    cell: ({ row }) => (row.getCanExpand() ? <ExpanderCell row={row} /> : null),
  };
}
